<template>
  <div id="index">
    <!-- 头部 -->
    <!-- <div id="preloader"></div> -->
    <header class="header-one">
      <!-- header-area start -->
      <div
        id="sticker"
        class="header-area hidden-xs"
        :class="{ stick: nScrollTop > 100 }"
      >
        <div class="container">
          <div class="row">
            <!-- logo start -->
            <div class="col-md-3 col-sm-3">
              <div class="logo">
                <!-- Brand -->
                <router-link
                  class="navbar-brand page-scroll sticky-logo"
                  to="/Home"
                >
                  <img
                    draggable="false"
                    src="../assets/new/img/logo/logo2.png"
                    alt
                  />
                </router-link>
              </div>
            </div>
            <!-- logo end -->
            <div class="col-md-9 col-sm-9">
              <!-- mainmenu start -->
              <nav class="navbar navbar-default">
                <div class="collapse navbar-collapse" id="navbar-example">
                  <div class="main-menu">
                    <ul class="nav navbar-nav navbar-right pc1111">
                      <li>
                        <router-link to="/Home">首页</router-link>
                      </li>
                      <li>
                        <router-link to="/DownLoad">下载</router-link>
                      </li>
                      <li>
                        <router-link to="/Blog">新闻</router-link>
                      </li>
                      <!-- <li>
                        <a class="pagess">公告</a>
                        <ul class="sub-menu">
                          <li>
                            <router-link to="/TextA">关于A</router-link>
                          </li>
                        </ul>
                      </li>-->
                      <li>
                        <router-link to="/faq">常见问题</router-link>
                      </li>
                      <li>
                        <a class="pagess">关于我们</a>
                        <ul class="sub-menu">
                          <li>
                            <router-link to="/aboutxy_details"
                              >关于星瀛科技</router-link
                            >
                          </li>
                          <li>
                            <router-link to="/aboutus_details"
                              >关于海星云</router-link
                            >
                          </li>
                          <li>
                            <router-link to="/Contact">商务合作</router-link>
                          </li>
                        </ul>
                      </li>

                      <!-- pc端 -->
                      <dl class="u-reaged">
                        <dt>
                          <a class="o1" @click="Signln">
                            <i class="iconfont">&#xe687;</i>
                            <span>&nbsp;&nbsp;{{ qiehuan }}</span>
                          </a>
                          <el-popover
                            v-if="tokenen && !mobile_flag"
                            placement="bottom"
                            width="250"
                            trigger="click"
                            popper-class="popper-class-override"
                          >
                            <div id="qrcode" class="payCode"></div>
                            <!-- <p>请使用手机扫描二维码完成支付</p> -->
                            <div class="qrcode-box">
                              <img
                                draggable="false"
                                class="recharge-qrcode-img"
                                v-show="rechargeQRCodeUrl"
                                :src="rechargeQRCodeUrl"
                                alt="充值二维码"
                              />
                            </div>
                            <div class="recharge-desc-box">
                              <div class>请使用手机扫描二维码</div>
                              <div>打开充值</div>
                            </div>
                            <el-button
                              class="o2"
                              slot="reference"
                              style="border-radius: 26px"
                              @click="Rechargeing"
                            >
                              <i class="iconfont">&#xe67b;</i>&nbsp;&nbsp;充值
                            </el-button>
                          </el-popover>
                          <a v-else class="o2" @click="Signln">
                            <i class="iconfont">&#xe67b;</i>
                            <span>&nbsp;&nbsp;充值</span>
                          </a>
                          <a class="o3" @click="Register" v-if="tokenen">
                            <i class="iconfont">&#xe6e9;</i>
                            <span>&nbsp;&nbsp;{{ zczx }}</span>
                          </a>
                        </dt>
                      </dl>
                    </ul>
                  </div>
                </div>
              </nav>
              <!-- mainmenu end -->
            </div>
          </div>
        </div>
      </div>
      <!-- header-area end -->
      <!-- 手机 mobile-menu-area start -->
      <div class="mobile-menu-area hidden-lg hidden-md hidden-sm">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="mobile-menu">
                <div class="logo">
                  <router-link
                    class="navbar-brand page-scroll sticky-logo"
                    to="/Home"
                  >
                    <img
                      draggable="false"
                      src="../assets/new/img/logo/logo2.png"
                      alt
                    />
                  </router-link>
                </div>
                <nav id="dropdown" class="sj22222">
                  <ul>
                    <li>
                      <router-link to="/Home">首页</router-link>
                    </li>
                    <li>
                      <router-link to="/DownLoad">下载</router-link>
                    </li>
                    <li>
                      <router-link to="/Blog">新闻</router-link>
                    </li>
                    <li>
                      <router-link to="/faq">常见问题</router-link>
                    </li>
                    <li>
                      <a class="pagess">关于我们</a>
                      <ul class="sub-menu">
                        <li>
                          <router-link to="/aboutxy_details"
                            >关于星瀛科技</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/aboutus_details"
                            >关于海星云</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/Contact">商务合作</router-link>
                        </li>
                      </ul>
                    </li>
                    <!-- 手机端 -->

                    <dl class="u-reaged" style="font-size: 70%">
                      <dt>
                        <a class="o1" @click="Signln" id="Signln11">
                          <span>{{ qiehuan }}</span>
                        </a>

                        <a class="o2" @click="Rechargeing" id="Signln22">
                          <span>充值</span>
                        </a>
                        <a
                          class="o3"
                          @click="Register"
                          v-if="tokenen"
                          id="Signln33"
                        >
                          <span>{{ zczx }}</span>
                        </a>
                      </dt>
                    </dl>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- mobile-menu-area end -->
    </header>

    <div class="content">
      <router-view></router-view>
    </div>
    <!-- Start Footer bottom Area -->
    <footer>
      <div class="footer-area">
        <div class="container">
          <div class="row row_BT">
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="footer-content fc_BT">
                <div class="footer-head fh_BT">
                  <h4>商务合作</h4>
                  <p>欢迎商务合作洽谈</p>
                  <div class="footer-contacts">
                    <p><span>电话 :</span> 010-8846-4460</p>
                    <p><span>邮箱 :</span> business@starvictory.com</p>
                    <p>
                      <span>公司地址 :</span> 北京市海淀区中间建筑西杉创意园
                      <br />二区18号楼03
                    </p>
                    <p><span>客服电话(微信号同号) :</span> 13910156055
                      <br />&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;13552315309
                      <br />&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;18811775763
                    </p>
                  </div>
                  <div class="footer-icons">
                    <ul>
                      <!-- <li>
                        <a>
                        <i class="fa fa-wechat"></i>
                        </a>
                      </li>-->
                      <li class="fa_li">
                        <a>
                          <i class="fa fa-qq"></i>
                          <div class="fa_img">
                            <img
                              draggable="false"
                              :src="`https://haixingcloud.oss-cn-beijing.aliyuncs.com/static/web_static/images/web_h5/qrcode/qqCode.png`"
                            />
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!-- end single footer -->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="footer-content">
                <div class="footer-head">
                  <!-- <h4>友情链接</h4> -->
                  <div class="footer-services-link">
                    <ul class="footer-list">
                      <li>
                        <a href="http://www.10086.cn/" target="view_window"
                          >中国移动</a
                        >
                      </li>
                      <li>
                        <a
                          href="http://www.chinatelecom.com.cn/"
                          target="view_window"
                          >中国电信</a
                        >
                      </li>
                      <li>
                        <a
                          href="http://www.chinaunicom.com.cn/"
                          target="view_window"
                          >中国联通</a
                        >
                      </li>
                      <li>
                        <a href="http://sj.zol.com.cn/" target="view_window"
                          >ZOL手机应用</a
                        >
                      </li>
                      <!-- <li>
                                            <a href="https://store.steampowered.com/">Steam</a>
                      </li>-->
                      <!-- <li>
                                            <a href="https://www.epicgames.com/store/zh-CN/">Epic games</a>
                      </li>-->
                    </ul>
                    <ul class="footer-list">
                      <li>
                        <a href="http://www.lenovo.com.cn/" target="view_window"
                          >联想</a
                        >
                      </li>
                      <li>
                        <a href="https://www.intel.cn/" target="view_window"
                          >英特尔</a
                        >
                      </li>
                      <li>
                        <a href="http://xiazai.zol.com.cn/" target="view_window"
                          >ZOL应用下载</a
                        >
                      </li>

                      <!-- <li>
                                            <a href="https://uplay.ubisoft.com/">Uplay</a>
                      </li>
                      <li>
                                            <a href="https://www.origin.com/">Origin橘子</a>
                      </li>
                      <li>
                        <a href="https://www.intel.cn/">英特尔</a>
                      </li>
                      <li>
                                            <a href="http://www.wanmei.com/">完美世界</a>
                      </li>
                      <li>
                                            <a href="https://www.mediatek.cn/">联发科</a>
                      </li>
                      <li>
                                            <a href="https://en.cdprojektred.com/">“波兰蠢驴”</a>
                      </li>-->
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!-- end single footer -->
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="footer-content last-item">
                <div class="footer-head" style="text-align: center">
                  <h4>关注星瀛科技公众号有惊喜哦！</h4>
                  <!-- <p>Are you looking for professional games services for your new games. Are you looking for professional developer for your new games.</p> -->

                  <img
                    draggable="false"
                    src="../assets/images/hxy_weixin.jpg"
                    style="height: 210px"
                  />
                  <!-- <div class="subs-feilds">
                    <div class="suscribe-input">
                      <input
                        type="email"
                        class="email form-control width-80"
                        id="sus_email"
                        placeholder="Type Email"
                      />
                      <button type="submit" id="sus_submit" class="add-btn">Subscribe</button>
                    </div>
                  </div>-->
                </div>
              </div>
            </div>
            <!-- end single footer -->
          </div>
        </div>
      </div>
      <!-- End footer area -->
      <div class="footer-area-bottom">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="copyright">
                <p>
                  Copyright © 2020.
                  <a>星瀛科技(北京)有限公司</a> 版权所有
                  <a
                    class="num"
                    href="https://beian.miit.gov.cn"
                    target="_blank"
                    >京ICP备19011284号</a
                  >
                  |
                  <img
                    src="../assets/gh.png"
                    style="width: 16px; height: 16px"
                  />
                  <a
                    class="num"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035401"
                    target="_blank"
                    >京公网安备 11010802035401号</a
                  >
                </p>
              </div>
              <!-- <div style="width: 300px; margin: 0 auto; padding: 20px 0">
                <a
                  target="_blank"
                  href=" "
                  style="
                    display: inline-block;
                    text-decoration: none;
                    height: 20px;
                    line-height: 20px;
                  "
                >
                  <img src="../assets/gh.png" style="float: left" />
                  <p
                    style="
                      float: left;
                      height: 20px;
                      line-height: 20px;
                      margin: 0px 0px 0px 5px;
                      color: #939393;
                    "
                  >
                    京公网安备 11010802035401号
                  </p></a
                >
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </footer>

    <newLogin ref="Login1"></newLogin>
    <div>
      <yzm ref="erweima"></yzm>
    </div>
    <!-- <LoginSucce ref="LoginSucce"></LoginSucce> -->
  </div>
</template>

<script>
import newLogin from '@/base/newLogin.vue'
import LoginSucce from '@/base/LoginSucce.vue'
import adaption from '@/mixi/adaption'
// import QRCode from 'qrcodejs2'
import QRCode from 'qrcode'

import yzm from '../base/yzm'
export default {
  mixins: [adaption],
  // 接收注入的数据
  inject: [
    'reload'
  ],
  components: {
    newLogin,
    LoginSucce,
    yzm
  },
  metaInfo: {
    title: '云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content: '海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content: '海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },

  data () {
    return {
      nScrollTop: 0,
      isActive: false, // 往上
      tokenen: '',
      // 切换登录 和 个人中心
      qiehuan: '注册/登录',
      // 切换注册 和 注销
      zczx: '注册/登录',
      // 二维码图片src
      rechargeQRCodeUrl: ''
    }
  },
  methods: {
    showRouter () {
      // 调用reload方法，刷新整个页面
      this.reload()
    },
    windowScroll () {
      // 滚动条距离页面顶部的距离
      // 以下写法原生兼容
      let scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop
      this.nScrollTop = scrollTop
    },

    // 登录
    Signln () {
      this.$store.commit('addWXshutDown', false)
      this.$refs.erweima.hidden_er()
      this.$nextTick(() => {
        this.$refs.Login1.FatherIndex()
        this.$refs.Login1.switchLogin(4)
        this.$refs.Login1.qrShow = true
      })
      if (this.qiehuan == '个人中心') {
        this.$router.push('./Center')
        // this.$router.push('./Pro_download')
      } else {
        this.$refs.Login1.bLogin1 = true
        this.$refs.Login1.nwxLogin = 1
      }
      this.$refs.Login1.longinMS()
    },
    // 充值
    Rechargeing () {
      console.log(this.tokenen)
      if (this.tokenen) {
        let userName = window.localStorage.getItem('user_name')
        let vip_level = window.localStorage.getItem('vip_level')
        // 获 取 个 人 信 息
        this.http.getUserInfo({token: this.tokenen, username: 'username'}).then(res => {
          console.log(res)
          let result = {}
          if (res.status !== 200) {
            this.$message.info('获取个人信息请求失败')
            return
          }
          result = res.data
          if (result.code !== 200) {
            this.$message.info(result.$message)
            return
          }
          let userInfo = result.data
          let phone = userInfo.phone
          let vipLevel = userInfo.vip_level
          let pay = `https://www.haixingcloud.com:8002/#/pay?userName=${phone}&level=${vipLevel}`
          if (this.mobile_flag) {
            // 手机充值
            window.location.href = pay
          } else {
            // 弹出充值二维码
            if (this.rechargeQRCodeUrl) return
            this.generateQR(pay)
            // window.location.href = `${window.location.protocol}//${window.location.host}/#/Rechargeing`
          }
        })
      } else {
        // console.log(`${window.location.protocol}//${window.location.host}/#/Home?flag=1`)
        window.location.href = `${window.location.protocol}//${window.location.host}/#/Home?flag=1`
        if (this.tokenen == '') {
          this.$message('请先登录')
          const that = this
          setTimeout(() => {
            that.$nextTick(() => {
              that.$refs.Login1.bLogin1 = true
              that.$refs.Login1.nwxLogin = 3
            })
          }, 800)
        }
      }
    },
    // 生成二维码图片
    generateQR (pay) {
      QRCode.toDataURL(pay).then(res => {
        this.rechargeQRCodeUrl = res
      }).catch(error => {
        console.warn(error)
        this.$message.info('生成二维码异常')
      })
    },
    // 注册
    Register () {
      if (this.tokenen != '') {
        this.$cookieStore.delCookie('user_sess')
        window.localStorage.removeItem('state')
        window.location.href = `${window.location.protocol}//${window.location.host}/#/Home`
        window.location.reload()
      } else {
        this.$refs.Login1.bLogin1 = true
        this.$refs.Login1.nwxLogin = 1
      }
    }
  },
  created () {
    // 返回顶部
    var that = this
    window.οnscrοll = function () {
      if (document.documentElement.scrollTop > 60) {
        that.isActive = true
      } else {
        that.isActive = false
      }
    }

    this.$nextTick(() => {
      this.$refs.Login1.switchLogin(4)
      this.$refs.Login1.qrShow = true
    })
  },
  mounted () {
    // console.log(typeof this.$cookieStore.getCookie('user_sess'))
    if (this.$route.query.Rechargelogin) {
      console.log(this.$route.query.Rechargelogin)
      // http://192.168.50.137:8002/#/pay?userName=&level=&invtecode=M5H7GZ5R
      this.$message({
        type: 'warning',
        message: '请先在官网登陆（只能验证码注册、登陆 或 密码登陆）'
      })
      setTimeout(() => {
        this.Signln()
      }, 1000)
    }

    this.$on('global:denglu', () => {
      this.Signln()
    })
    window.addEventListener('scroll', this.windowScroll)
    this.tokenen = this.$cookieStore.getCookie('user_sess')
    console.log(typeof this.tokenen)
    this.$store.commit('addCount', this.tokenen)
    if (this.tokenen != '') {
      this.qiehuan = '个人中心'
      this.zczx = '注销'
    } else if (this.tokenen == '') {
      this.qiehuan = '注册/登录'
      this.zczx = '注册/登录'
    }

    this.$nextTick(() => {
      var mean_menu = $('nav#dropdown')
      mean_menu.meanmenu()

      $('#Signln11').click(() => {
        this.Signln()
      })
      $('#Signln22').click(() => {
        this.Rechargeing()
      })
      $('#Signln33').click(() => {
        this.Register()
      })
    })
    console.log('999888666')
  }
}
</script>

<style>
.popper-class-override {
  padding: 20px 0 0 0 !important;
  border: none !important;
  outline: none !important;
  background-color: #25304c !important;
  border-radius: 8px !important;
  /* background: transparent !important; */
  /* min-width: 115px !important; */
}
.popper-class-override .qrcode-box {
  width: 160px;
  height: 160px;
  overflow: hidden;
  margin: 20px auto;
}
.popper-class-override .qrcode-box .recharge-qrcode-img {
  width: 100%;
  height: 100%;
}
.popper-class-override .popper__arrow {
  border-bottom-color: #25304c !important;
}
.popper-class-override .popper__arrow::after {
  border-bottom-color: #25304c !important;
}
.popper-class-override .recharge-desc-box {
  margin-bottom: 30px !important;
  color: #fff !important;
}
.el-popover {
  text-align: center;
}
.payCode img {
  display: block;
  width: 180px;
  height: 180px;
  margin: 20px auto;
  background-color: #fff;
  padding: 6px;
}
.payCode p {
  text-align: center;
}
.fa_li {
  position: relative;
}
.fa_img {
  position: absolute;
  left: 56px;
  top: 0px;
  width: 120px;
  height: 120px;
  display: none;
}
.fa_img img {
  width: 100%;
  height: 100%;
}
.fa_li:hover .fa_img {
  display: block !important;
}
.row_BT {
  height: 380px;
}
.fc_BT {
  height: 440px;
}
.fh_BT {
  height: 380px;
}
.dropdown ul li a {
  font-size: 25px;
}
.footer-area-bottom .copyright p {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue